/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ seats: NonNullable<unknown>, price: NonNullable<unknown> }} Cost_Calc_Seats_PriceInputs */



/**
* | output |
* | --- |
* | "{seats} seats × €{price}" |
*
* @param {Cost_Calc_Seats_PriceInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const cost_calc_seats_price = /** @type {((inputs: Cost_Calc_Seats_PriceInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cost_Calc_Seats_PriceInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.seats} Plätze × €${i?.price}`)
	return /** @type {LocalizedString} */ (`${i?.seats} seats × €${i?.price}`)
});